/**
 * Conversion tracking for ad platforms (Google Ads/GA4, Meta Pixel, Microsoft/Bing UET).
 * IDs are loaded at runtime from /api/marketing/config (set by admin), so platforms can
 * optimize campaigns toward real customers. Each pixel only loads if its ID is configured.
 */

let CONFIG = {};
let initialized = false;

function loadScript(src) {
    return new Promise((resolve) => {
        const s = document.createElement("script");
        s.async = true;
        s.src = src;
        s.onload = resolve;
        s.onerror = resolve;
        document.head.appendChild(s);
    });
}

export function initTracking(config) {
    if (initialized || !config) return;
    CONFIG = config || {};
    initialized = true;

    // --- Google: GA4 + Google Ads (gtag.js) ---
    const gtagId = CONFIG.ga4_id || CONFIG.google_ads_id;
    if (gtagId) {
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () { window.dataLayer.push(arguments); };
        window.gtag("js", new Date());
        if (CONFIG.ga4_id) window.gtag("config", CONFIG.ga4_id);
        if (CONFIG.google_ads_id) window.gtag("config", CONFIG.google_ads_id);
        loadScript(`https://www.googletagmanager.com/gtag/js?id=${gtagId}`);
    }

    // --- Meta (Facebook/Instagram) Pixel ---
    if (CONFIG.meta_pixel_id) {
        /* eslint-disable */
        !(function (f, b, e, v, n, t, s) {
            if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
            if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
            t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
        })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
        /* eslint-enable */
        window.fbq("init", CONFIG.meta_pixel_id);
        window.fbq("track", "PageView");
    }

    // --- Microsoft / Bing UET ---
    if (CONFIG.bing_uet_id) {
        /* eslint-disable */
        (function (w, d, t, r, u) {
            var f, n, i; w[u] = w[u] || [], f = function () { var o = { ti: CONFIG.bing_uet_id, enableAutoSpaTracking: true }; o.q = w[u], w[u] = new UET(o), w[u].push("pageLoad"); },
            n = d.createElement(t), n.src = r, n.async = 1, n.onload = n.onreadystatechange = function () { var s = this.readyState; s && s !== "loaded" && s !== "complete" || (f(), n.onload = n.onreadystatechange = null); },
            i = d.getElementsByTagName(t)[0], i.parentNode.insertBefore(n, i);
        })(window, document, "script", "//bat.bing.com/bat.js", "uetq");
        /* eslint-enable */
    }
}

function gtagEvent(name, params = {}) {
    if (window.gtag) window.gtag("event", name, params);
}

/** Fire a named conversion across every configured platform. */
export function track(eventName, params = {}) {
    try {
        gtagEvent(eventName, params);
        if (window.fbq) {
            const fbMap = { sign_up: "CompleteRegistration", start_trial: "StartTrial", purchase: "Purchase", begin_checkout: "InitiateCheckout" };
            window.fbq("track", fbMap[eventName] || eventName, params.value ? { value: params.value, currency: params.currency || "USD" } : {});
        }
        if (window.uetq) {
            window.uetq.push("event", eventName, params.value ? { revenue_value: params.value, currency: params.currency || "USD" } : {});
        }
    } catch (e) { /* never break the app for analytics */ }
}

export function trackSignup() {
    track("sign_up");
}

export function trackTrialStart(value, plan) {
    track("start_trial", { value: value || 0, currency: "USD", items: plan ? [{ item_name: plan }] : undefined });
    // Google Ads conversion (uses dedicated label if provided)
    if (window.gtag && CONFIG.google_ads_id && CONFIG.google_ads_purchase_label) {
        window.gtag("event", "conversion", { send_to: `${CONFIG.google_ads_id}/${CONFIG.google_ads_purchase_label}`, value: value || 0, currency: "USD" });
    }
}

export function trackPurchase(value, plan) {
    track("purchase", { value: value || 0, currency: "USD", items: plan ? [{ item_name: plan }] : undefined });
    if (window.gtag && CONFIG.google_ads_id && CONFIG.google_ads_purchase_label) {
        window.gtag("event", "conversion", { send_to: `${CONFIG.google_ads_id}/${CONFIG.google_ads_purchase_label}`, value: value || 0, currency: "USD" });
    }
}
